<app-activity-log-grid [entityId]="opportunityId()" [entityTypeId]="entityType"></app-activity-log-grid>
